import { createContext, useContext } from "react";
import { toast } from "react-toastify";

import { appSettings } from "../config/appConfig";
import { logOutPage } from "../components/utils/logOut.js";

const ApplicationIntegrationContext = createContext();

export const ApplicationIntegrationContextProvider = ({ children }) => {
  const baseUrl = appSettings.serverBaseUrl;

  const registerOnBigin = async () => {
    const res = await fetch(`${baseUrl}/integration/oauth/start`, {
      method: "GET",
      credentials: "include",
    });
    const { redirectUrl } = await res.json(); // your backend sends the Zoho URL
    window.location.href = redirectUrl;
  };

  const getChatbotBiginLeadFlows = async () => {
    try {
      const res = await fetch(
        `${baseUrl}/integration/get-chatbot-bigin-lead-flows`,
        {
          method: "get",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const response = await res.json();

      if ("isValidToken" in response && !response?.isValidToken) {
        logOutPage();
        return [];
      }

      if (response?.Error) {
        toast.error(response.Error);
        return [];
      }

      return response;
    } catch (err) {
      toast.error("Failed to fetch bigin integration flow");
      return [];
    } finally {
    }
  };

  return (
    <ApplicationIntegrationContext.Provider
      value={{
        registerOnBigin,
        getChatbotBiginLeadFlows,
      }}
    >
      {children}
    </ApplicationIntegrationContext.Provider>
  );
};

export const useApplicationIntegrationContext = () =>
  useContext(ApplicationIntegrationContext);
